import React, {useContext, useState} from "react";
import axios from "axios";
import {Elink, UploadImageUrl, CompanySubdomain} from "../CommonComponents/Routes";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import imageCompression from "browser-image-compression";
import DragAndDrop from "./DragAndDrop";
import "./Inventory.css"

export default () => { //used to  show or upload the images on the client portal
    let PageView = useContext(ViewMangementContext)
    const [HideSpan, setHideSpan] = useState(false)
    const [imageModal, setimageModal] = useState("")
    let RecordsManagement = useContext(RecordsManagementContext)
    let Estimate = RecordsManagement.CP_PageDetails.EstimateDetails.JobDetails
    Estimate = Estimate.JobDetails == undefined ? Estimate : Estimate.JobDetails
    let EventExist = Estimate.EventExist
    let ViewManagement = useContext(ViewMangementContext)
    let loadingImage = <img src={process.env.PUBLIC_URL + "/Images/Loader18.gif"} alt="" style={{width: "350px"}}/>
    let DocumentImages = RecordsManagement.CP_PageDetails.EstimateAndCompanyInfo.Estimate.EstimateDocument
    let subdomains = RecordsManagement.CP_PageDetails.subdomains
    const getFile = async (file) => {
        let b = []
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        let allowedExtension = ["jpg", "jpeg", "gif", "png", "JPG", "JPEG", "GIF", "PNG"];
        for (let i=0; i < file.length; i++) {
            let extName =  allowedExtension.indexOf(file[i].name.split('.').pop()) > -1
            let message = extName ? file[i].name+ " is not saved, picture quality of "+file[i].name+"  is too low" : file[i].name+ " is not saved, Only image file with extension: .jpg, .jpeg, .gif or .png is allowed"
            if ( extName && file[i].size > 1000){
                const compressedFile = file[i].size > 1000000 ? await imageCompression(file[i], options) : file[i];
                let cp = await toBase64(compressedFile)
                b.push(cp)
            }else{
                ViewManagement.setAlertProperty({
                    Message: message,
                    Type: "warning",
                    Show: true,
                    AutoHide: false
                })
            }
        }
        return b;
    }

    const onImageChange =  async (event) => {//save the images and send to the "upload_image" function through post request in "client_portal_controller" to save the images
        let file = event.target !== undefined ? event.target.files : event

        if (file && file.length <= 6) {
            setHideSpan(true)
            let a = await getFile(file) // it will check the extension and size of the image and if needed it will compress the images
            try {
                let cookie = document.cookie.split('employee_id=')[1]
                axios({
                    method: 'post',
                    url: UploadImageUrl,
                    data: {
                        estimate_key: Elink,
                        employee_key: cookie,
                        a: a
                    }
                }) .then((response) => {
                    {
                        setHideSpan(false)
                        if (event.target !== undefined){
                            event.target.value = null;
                        }
                        // console.log(response.data.EstimateAndCompanyInfo.Estimate.EstimateDocument)
                        RecordsManagement.SetCP_PageDetails({
                            ...RecordsManagement.CP_PageDetails,
                            EstimateAndCompanyInfo : {
                                ...RecordsManagement.CP_PageDetails.EstimateAndCompanyInfo,
                                Estimate: {
                                    ...RecordsManagement.CP_PageDetails.EstimateAndCompanyInfo.Estimate,
                                    EstimateDocument: response.data
                                }
                            }
                        })
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }else {//if select images are more than 6 then it will shows the alert message.
            if (event.target !== undefined){
                event.target.value = null;
            }
            ViewManagement.setAlertProperty({
                Message: "You can select up to six images",
                Type: "warning",
                Show: true,
                AutoHide: true
            })
        }
    }

    const toBase64 = file => new Promise((resolve, reject) => {//encode the images
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const zoomImage = (image) => {//used for adding the feature of zoom in to the image
        if(subdomains.includes(CompanySubdomain)){
            setimageModal(image)
        }
        else {
            setimageModal(image.replace("thumb", "medium"))
        }
    }
    const ClearModal = () => {
        localStorage.setItem("loading", "no")
        PageView.setModalContent({Title: '', Body: '', Class: ''})
    }

    return (
        <>
            {HideSpan ? <div style={{ zIndex: 9999, position: "absolute"}}
            >{loadingImage}</div> : <></>}
            <div style={ HideSpan ? {pointerEvents: "none", opacity: "0.3",zIndex:800}
                : {}}>
                {EventExist ?
                     <></> :
                    <DragAndDrop handleDrop={onImageChange}>
                        <div id={"div-test"} style={{
                            border: 'dashed grey 4px',
                            backgroundColor: 'rgba(255,255,255,.8)',
                            // position: 'absolute',
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 9999
                        }}>
                            <label htmlFor="inputTag" id={"Test-lbl"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#b5b5b5"
                                     className="bi bi-download" viewBox="0 0 16 16">
                                    <path
                                        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                    <path
                                        d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                </svg>
                                <br/>
                                Choose a file or drag it here. <br/>
                                <input type="file" id="inputTag" multiple="true" onChange={onImageChange}
                                       className="filetype" accept='image/*'/>
                                <br/>
                                <span id="imageName"></span>
                            </label>
                        </div>
                    </DragAndDrop>
                }
                <div style={{maxHeight: "200px", overflow: "auto", backgroundColor: "white", marginTop: "2%"}}>
                    {Object.entries(DocumentImages).reverse().map(([id, image]) => {
                        var src, img
                        if(subdomains.includes(CompanySubdomain)){
                            src = image[0]
                            img = image[1]
                        }
                        else {
                            src = image
                            img = image
                        }
                        return (<img style={{margin: "4%", height: "60px", width: "100px"}} onClick={()=> zoomImage(img)} data-toggle="modal"
                                     data-target="#Modal-2" src={src} alt="preview image" />)
                    })}
                </div>
            </div>
            <div className={"modal fade zoom-image-class"} id="Modal-2" tabIndex="-1" role="dialog"
                 aria-labelledby="ModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered" style={{maxWidth: "50rem"}} role="document">
                    <div className="modal-content" id={"zoom-image-class"}>
                        <div className="modal-header">
                            {/*<h5 className="modal-title" id="ModalLabel">{Modal.Title}</h5>*/}
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" onClick={()=>ClearModal()}>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {<img style={{marginTop: "2%", height: "100%", width: "100%"}} src={imageModal} alt="preview image" />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

